/* eslint-disable */
export const DASHBOARD = [
  
  {
    text: "Educators",
    to: () => ({
      name: "user-dashboard"
    })
  }
];
